var map = {
	"./blog-big-1.jpg": 2963,
	"./blog-big-2.jpg": 388,
	"./blog-big-3.jpg": 337,
	"./team-01.jpg": 1631,
	"./team-02.jpg": 8016,
	"./team-03.jpg": 9149
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4346;